import { getMyOkr } from '@/graphql/okr'
import { getOkrListIdByCycle } from '@/api/okr'
import { getOkrWeeklyListByOId, getOkrWeeklyRiskByOId } from '@/api/weekly'
import { useStore } from 'vuex'
import moment from 'moment'
import { ref, computed, watch } from 'vue'
export default function useOkr (props, selectedWeek, allOrCurrent) {
  const loadings = ref([true, true])
  const data = ref([])

  const okrId = ref()

  const objectives = ref([])
  async function getOkrByCycle (cycleId, userId) {
    if (!cycleId) {
      return
    }
    loadings.value[1] = true
    data.value = []
    getOkrListIdByCycle(cycleId, userId)
      .then(res => {
        okrId.value = res.id
        return getMyOkr(res.id)
      })
      .then(res => {
        objectives.value = res.objectives
        data.value = []
      })
      .finally(() => {
        loadings.value[1] = false
      })
  }

  const store = useStore()
  const selectedCycleId = computed(() => store.state.selectedCycleId)
  watch(selectedCycleId, cycleId => getOkrByCycle(cycleId, props.userId))
  getOkrByCycle(selectedCycleId.value, props.userId)

  const map = ref(new Map())
  const riskMap = ref(new Map())
  watch([objectives, selectedWeek], vals => {
    if (!vals[0] || !vals[1]) {
      return
    }
    loadings.value[0] = true
    // 获取周报
    const childObjectiveIds = []
    vals[0].forEach(o => {
      o.keyResults.forEach(kr => {
        kr.linkedFromStatements.forEach(childObjective => {
          childObjectiveIds.push(childObjective.relatedObjectiveId.id)
        })
      })
    })
    getOkrWeeklyListByOId(childObjectiveIds, vals[1], vals[1]).then(weekData => {
      map.value = new Map()
      weekData.forEach(item => {
        if (!map.value.has(item.keyresultId)) {
          map.value.set(item.keyresultId, {})
        }
        map.value.get(item.keyresultId)[item.weekDate] = item
      })
    }).finally(() => {
      loadings.value[0] = false
    })
    getOkrWeeklyRiskByOId(childObjectiveIds, vals[1], vals[1]).then(risk => {
      riskMap.value = new Map()
      risk.forEach(item => {
        if (!riskMap.value.has(item.keyresultId)) {
          riskMap.value.set(item.keyresultId, {})
        }
        riskMap.value.get(item.keyresultId)[item.weekDate] = item
      })
    }).finally(() => {
      loadings.value[0] = false
    })
  })

  watch([map, riskMap], () => {
    map.value.forEach((val, keyresultId) => {
      Object.keys(val).forEach(weekDate => {
        val[weekDate].currentRiskToEdit = (riskMap.value.get(keyresultId) || {})[weekDate]?.currentRisk || val[weekDate].currentRisk
      })
    })
  })

  watch([objectives, allOrCurrent], () => {
    const items = []
    objectives.value.forEach((o, index) => {
      const objectiveRowsCount = ref(0)
      o.keyResults
        .forEach((kr, krIndex, arr) => {
          const krRowsCount = ref(0)
          kr.linkedFromStatements.forEach((childObjective, childObjectiveIndex, childObjectiveArr) => {
            childObjective.relatedObjectiveId.keyResults
              .filter(childKr => allOrCurrent.value === 'ALL' || Object.values((map.value.get(childKr.id) || {})).filter(item => item.currentRisk).length)
              .forEach((childKr, childKrIndex, childKrArr) => {
                const krItem = {
                  objectiveId: o.id,
                  objectiveContent: o.content,
                  krId: kr.id,
                  krContent: kr.content,
                  name: childObjective.createUid.name,
                  childKrId: childKr.id,
                  childKrContent: childKr.content,
                  childKrCollaborativeUsers: childKr.collaborators.map(item => item.name).join(','),
                  childKrIndicator: childKr.indicator,
                  childKrStartDay: childKr.startDay
                    ? moment.unix(childKr.startDay).format('YYYY-MM-DD')
                    : undefined,
                  childKrEndDay: childKr.finishDay
                    ? moment.unix(childKr.finishDay).format('YYYY-MM-DD')
                    : undefined,
                  childKrProgress: childKr.progress,
                  rowId: `${o.id}-${kr.id}-${childKr.id}`,
                  childObjectiveRowIndex: childKrIndex,
                  childObjectiveRowsCount: childKrArr.length,
                  krRowIndex: krRowsCount.value,
                  krRowsCount: krRowsCount,
                  objectiveRowIndex: objectiveRowsCount.value,
                  objectiveRowsCount: objectiveRowsCount,
                  week: computed(() => {
                    if (!map.value.get(childKr.id)) {
                      map.value.set(childKr.id, [])
                    }
                    return map.value.get(childKr.id) || []
                  })
                }
                items.push(krItem)
                krRowsCount.value++
                objectiveRowsCount.value++
              })
          })
          if (!kr.linkedFromStatements.length) {
            const krItem = {
              objectiveId: o.id,
              objectiveContent: o.content,
              krId: kr.id,
              krContent: kr.content,
              rowId: kr.id,
              objectiveRowIndex: objectiveRowsCount.value,
              objectiveRowsCount: objectiveRowsCount
            }
            objectiveRowsCount.value++
            items.push(krItem)
          }
        })
    })
    data.value = items
  })

  return {
    data,
    okrId,
    riskBackup: riskMap,
    // loading: false
    loading: computed(() => loadings.value[0] || loadings.value[1])
  }
}
